export type ApiCredentialsFormState = {
  loading: boolean;
  error: string | null;
};

export const initialState: ApiCredentialsFormState = {
  error: null,
  loading: false
};